<script lang="ts">
  import BottomActionBar from '@ui/panels/BottomActionBar.svelte';
  import SettingsButton from '@ui/panels/SettingsButton.svelte';
  import SettingsModal from '@ui/modals/SettingsModal.svelte';
  import UpgradesModal from '@ui/modals/UpgradesModal.svelte';
  import WarehouseModal from '@ui/modals/WarehouseModal.svelte';
  import ProductionModal from '@ui/modals/ProductionModal.svelte';
  import SpectorDebugPanel from '@ui/components/SpectorDebugPanel.svelte';
  import ResourcePanel from '@ui/components/ResourcePanel.svelte';
  import { gameEventBus } from '@/game/events';
  import { onMount, onDestroy } from 'svelte';
  import { setAppMode } from '@/stores/ui/appState';
  let unsubscribe: (() => void)[] = [];

  // Состояние модальных окон
  let showUpgrades = false;
  let showWarehouse = false;
  let showProduction = false;

  onMount(() => {
    // Подписываемся на игровые события от BottomActionBar
    unsubscribe.push(gameEventBus.on('mode-click', handleModeClick));
  });

  onDestroy(() => {
    // Отписываемся от всех событий
    unsubscribe.forEach(fn => fn());
  });

  function handleModeClick(data: { modeId: string }) {
    const { modeId } = data;
    console.log('Mode clicked:', modeId);

    // Обрабатываем клики по режимам
    switch (modeId) {
      case 'upgrades':
        showUpgrades = true;
        break;
      case 'warehouse':
        gameEventBus.emit('warehouse-open');
        break;
      case 'production':
        gameEventBus.emit('production-open');
        break;
      case 'research':
        // TODO: Открыть исследования
        console.log('Research clicked');
        break;
      case 'market':
        // TODO: Открыть рынок
        console.log('Market clicked');
        break;
      default:
        console.log('Unknown mode:', modeId);
    }

    // Отправляем событие для других компонентов
    gameEventBus.emit('ui-panel-change', { panelId: modeId });
  }

  function handleUpgradePurchased(data: { upgradeId: string }) {
    console.log('Upgrade purchased:', data.upgradeId);
    // Можно добавить анимацию или звук
  }

  function handleUpgradesClose() {
    showUpgrades = false;
  }

  function handleCraftStarted(data: { craftId: string; quantity: number }) {
    console.log('Craft started:', data.craftId, 'x' + data.quantity);
    // Можно добавить анимацию или звук
  }
</script>

<div class="game-hud">
  <div class="absolute top-4 left-26 z-50 flex gap-2">
    <button class="dev-button" on:click={() => setAppMode('scene-editor')}> Scene Editor </button>
  </div>
  <SettingsButton />
  <!-- Панель ресурсов -->
  <ResourcePanel />
  <!-- Панель отладки Spector.js -->
  <SpectorDebugPanel />
  <!-- Нижняя панель действий -->
  <BottomActionBar />

  <!-- Модальные окна -->
  <SettingsModal />
  <UpgradesModal
    bind:isOpen={showUpgrades}
    onUpgradePurchased={handleUpgradePurchased}
    onClose={handleUpgradesClose}
  />
  <WarehouseModal bind:isOpen={showWarehouse} />
  <ProductionModal bind:isOpen={showProduction} onCraftStarted={handleCraftStarted} />
</div>

<style lang="postcss">
  @reference "@/styles/theme.css";

  .game-hud {
    @apply w-full h-full;
    @apply flex flex-col;
    @apply relative;
    @apply overflow-hidden;
  }

  .dev-button {
    background: rgba(128, 0, 128, 0.7);
    color: white;
    border: 1px solid var(--color-neon-pink);
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 12px;
  }
</style>
